import _ from 'lodash';

import { RESET_STATE } from 'store/global/actions';

import { LOAN_OFFICERS_MANAGEMENT_ACTION_TYPE } from '../actions';

const initialState = {
  loanOfficerUsersIds: [],
  loanOfficerManagerUsersIds: [],
  loanOfficerUsers: {},
  loanOfficerManagerUsers: {},
  relations: {},
};

const loanOfficersManagementReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case LOAN_OFFICERS_MANAGEMENT_ACTION_TYPE.GET_LOAN_OFFICER_USERS:
      return {
        ...state,
        loanOfficerUsersIds: payload.result,
        loanOfficerUsers: payload.entities.loanOfficerUsers,
      };

    case LOAN_OFFICERS_MANAGEMENT_ACTION_TYPE.GET_LOAN_OFFICER_MANAGER_USERS:
      return {
        ...state,
        loanOfficerManagerUsersIds: payload.result,
        loanOfficerManagerUsers: payload.entities.loanOfficerManagerUsers,
      };

    case LOAN_OFFICERS_MANAGEMENT_ACTION_TYPE.GET_RELATIONS_BETWEEN_LO_AND_LOM:
      return {
        ...state,
        relations: payload.entities.relations || {},
      };

    case LOAN_OFFICERS_MANAGEMENT_ACTION_TYPE.ADD_RELATIONS_BETWEEN_LO_AND_LOM: {
      const { dependentId } = payload;

      return {
        ...state,
        relations: {
          ...state.relations,
          [dependentId]: payload,
        },
      };
    }

    case LOAN_OFFICERS_MANAGEMENT_ACTION_TYPE.DELETE_RELATIONS_BETWEEN_LO_AND_LOM: {
      const { dependentId } = payload;

      return {
        ...state,
        relations: _.omit(state.relations, dependentId),
      };
    }

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default loanOfficersManagementReducer;
